import { Component, Input } from '@angular/core';
import { TemplateSection, TemplateSubSection } from 'src/app/core/models';

@Component({
  selector: 'app-section-renderer',
  templateUrl: './section-renderer.component.html',
  styleUrls: ['./section-renderer.component.scss']
})
export class SectionRendererComponent {
  @Input() node!: TemplateSection | TemplateSubSection;
  @Input() readonly = false;
  @Input() showValidation = false;
  @Input() headingLevel: 1 | 2 | 3 = 2;
  /** Suppress this node's own heading (used when a tab strip already shows the section name). */
  @Input() hideHeading = false;
}
